<template>
<b-modal ref="modal" visible size="lg" :hide-footer="true" title="Barcode connector" @hidden="$emit('close')">
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Selecteer de barcode scanner die je wilt gebruiker</h3>
        </div>
        <div class="block-content">
          <div class="row gutters-tiny">
            <div v-for="barcodeScanner in barcodeScanners" :key="barcodeScanner.id" class="col-md-6">
              <barcode-scanner-type icon="barcode"  @click="connectToBarcodeScanner(barcodeScanner.usb_device)">
                {{barcodeScanner.name}}
              </barcode-scanner-type>
            </div>
          </div>
        </div>
      </div>
</b-modal>
</template>

<script>
import BarcodeScannerType from './BarcodeScannerType.vue'
import Socket from './socket'
export default {
  components: {
    BarcodeScannerType
  },
  data () {
    return {
      barcodeScanners: null
    }
  },
  methods: {
    loadBarcodeScanners () {
      this.$api.getBarcodeScanners()
          .then((result) => {
            this.barcodeScanners = result.data
          })
          .catch(() => {
            this.$swal('Ehmm...', 'We konden geen barcode scanners vinden. Probeer het opnieuw.', 'warning')
          })
    },
    connectToBarcodeScanner (usbDevice) {
      var sendMessage = Socket.send(JSON.stringify({
        usb_device: usbDevice
      }))

      if (sendMessage) {
        Socket.connectedToBarcodeScanner = true
        this.$swal('Hoera 😊', `Succesvol verbonden met de barcode scanner.`, 'success')
        this.$refs.modal.hide()
      } else {
        this.$swal('Ehmm...', 'Er is iets misgegaan met het verbinden naar de barcode scanner. Probeer het opnieuw.', 'warning')
        this.$refs.modal.hide()
      }
    }
  },
  created () {
    this.loadBarcodeScanners()
  }
}
</script>


// WEBPACK FOOTER //
// BarcodeScannerDetailModal.vue?52ddcf95